import React, { useId } from "react";
import { IoCheckmarkCircle, IoTrashSharp } from "react-icons/io5";
import styled from "styled-components";
import ToolTip from "../reuse/ToolTip";

const FilenameContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  justify-content: space-between;
`;

const FilenameCheckIcon = styled.div`
  display: flex;
  align-items: center;
`;

const CheckIcon = styled(IoCheckmarkCircle)`
  color: ${({ theme }) => theme.colors.success};
`;

const CloseIcon = styled(IoTrashSharp)`
  color: ${({ theme }) => theme.colors.error};

  /* &:hover {
    color: ${({ theme }) => theme.colors.error};
  } */
`;

const getUploadedFile = (record) => {
  const fileFid = "file_F";
  const versionNo = record[fileFid]?.versions?.length;

  const url = record[fileFid]?.url;

  let fileName = "";
  if (versionNo && url) {
    fileName = record[fileFid]?.versions[versionNo - 1]?.fileName;
  } else if (record.file) {
    fileName = record.fileName;
  }

  return {
    rid: record?.id_F,
    fileName,
  };
};

export default function DocumentLists({
  documents,
  type,
  fid,
  handleRemoveFile,
}) {
  const toolTipId = useId();

  const onRemoveFile = (rid) => {
    handleRemoveFile(rid, fid);
  };

  if (documents.length > 0) {
    const documentList = documents.filter((x) => x.type_F === type);
    return (
      <div>
        {documentList.map((item) => {
          const { rid = "", fileName = "" } = getUploadedFile(item);

          return (
            <FilenameContainer key={rid}>
              <FilenameCheckIcon>
                <CheckIcon size={20} />
                <i>{fileName}</i>
              </FilenameCheckIcon>
              <div>
                <CloseIcon
                  size={20}
                  cursor="pointer"
                  onClick={() => {
                    onRemoveFile(rid);
                  }}
                  data-tooltip-id={toolTipId}
                />
                <ToolTip id={toolTipId} text="Remove File / Remover archivo" />
              </div>
            </FilenameContainer>
          );
        })}
      </div>
    );
  }

  return "";
}
